import { sectionType } from '@/views/website/products/components/description/common/types';

export const IDENTIFIER_TAGS = {};
export default {
  crawlType: 'freestyle_content',
  matchTemplates: [
    {
      type: sectionType.sectionFreestyle,
      tags: [],
      priority: 1,
    },
  ],
};
